export default __webpack_public_path__ + "locales/ru/SMTPSettings.json?hash=71f015b10657e07150d9d6b516b59580";